import { Heading } from "@tennr/frontend/components/Heading";
import "./CaseStudyCopy.css";

export const CaseStudyCopy = () => {
  return (
    <div className="case-study-copy">
      <Heading
        heading="How top teams use Tennr"
        title="CASE STUDIES"
        body="Explore the impact of our platform across subspecialties."
        color="dark"
        variant="section"
        wrapHeading="balance"
      />
    </div>
  );
};
